const INITIAL_STATE = {
  todos: [],
  carregando: false,
  erro: null,
  ultimo: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_ITEM':
      return {...state, carregando: true};
    case 'ERRO_ITEM':
      return {...state, carregando: false, erro: action.erro};
    case 'OBTER_TODOS_ITENS':
      return {...state, carregando: false, todos: action.itens};
    case 'NOVO_ITEM':
      return {...state, carregando: false, todos: state.todos.concat(action.item), ultimo: action.item};
    case 'ALTERAR_ITEM':
      return {...state, carregando: false, todos: state.todos.filter((item) => {return item.id!==action.item.id}).concat(action.item)};
    case 'REMOVER_ITEM':
      return {...state, carregando: false, todos: state.todos.filter((item) => {return item.id !== action.id})};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ItemReducer.js